module.exports = __webpack_public_path__ + "static/img/tccDriver.edba7ee6.png";